import Alert from 'components/ui/Alert/Alert';

const MaintenanceMessage = () => {
    return (
        <>
            {window.__env__.MAINTENANCE_ACTIVE === '1' ? (
                <Alert
                    variant="danger"
                    message="The system is under maintenance"
                />
            ) : null}
            {window.__env__.MAINTENANCE_ACTIVE === '0' &&
            window.__env__.MAINTENANCE_START !== '0' ? (
                <Alert
                    variant="warning"
                    message={`The system will undergo a scheduled maintenance at ${window.__env__.MAINTENANCE_START}`}
                />
            ) : null}
        </>
    );
};

export default MaintenanceMessage;
